import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';

import { IListFetcher } from '../../httpClient/fetchers/IListFetcher';
import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { mapRecTypeToBaseType } from '../../spacesPlatform/models/ContentType';
import { IViewRecommendationInfo } from '../models/IViewRecommendationInfo';
import { GetRecommendedViewsRequest } from '../serverApi/requests/GetRecommendedViewsRequest';
import { HideRecommendationRequest } from '../serverApi/requests/HideRecommendationRequest';
import { UndoHideRecommendationRequest } from '../serverApi/requests/UndoHideRecommendationRequest';

export namespace ViewRecommendations {

  let getRecommendedViews: IListFetcher<IViewRecommendationInfo> = null;

  export function viewRecommendations(): ResourceQuery<IViewRecommendationInfo> {
    if (getRecommendedViews === null) {
      getRecommendedViews = new WebClientListResourceFetcher(GetRecommendedViewsRequest, ServerApiMapper.vizRecommendations);
    }
    return new ResourceQuery(getRecommendedViews);
  }

  export function hideRecommendation(objectType: string, objectId: string): Promise<IResult> {
    return WebHttpClient.sendRequest(new HideRecommendationRequest({
      objectType: mapRecTypeToBaseType(objectType),
      objectId: objectId
    }));
  }

  export function undoHideRecommendation(objectType: string, objectId: string): Promise<IResult> {
    return WebHttpClient.sendRequest(new UndoHideRecommendationRequest({
      objectType: mapRecTypeToBaseType(objectType),
      objectId: objectId
    }));
  }

}

export type ViewRecommendations = typeof ViewRecommendations;
